import React from "react";
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem, ListSubheader, Autocomplete, FormHelperText } from "@mui/material";
import { doctorGroups, weightOptions, roomNoOptions, bloodGroupOptions, diagnosisOptions } from "../constants/options";

const BasicInfoSection = ({ formData, handleChange, handleNameChange, handleAutocompleteChange, handleBlur, errors }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField 
          label="Patient Name" 
          name="name" 
          InputProps={{ readOnly: true }} 
          fullWidth 
          onChange={handleNameChange} 
          value={formData.name || ''} 
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField
          label="Date"
          type="date"
          name="date"
          value={formData.date || ''}
          onChange={handleChange}
          fullWidth
          required
          InputLabelProps={{ shrink: true }}
          error={!!errors.date}
          helperText={errors.date}
          onBlur={handleBlur}
          inputProps={{
            min: new Date().toISOString().slice(0, 10), // prevents past dates conditionally if it was datetime
          }}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Room No"
          name="room_no"
          value={formData.room_no || ''}
          onChange={handleChange}
          fullWidth
          required
          error={!!errors.room_no}
          helperText={errors.room_no}
          onBlur={handleBlur}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth required error={!!errors.consultant}>
          <InputLabel id="consultant-label">Consultant</InputLabel>
          <Select
            labelId="consultant-label"
            label="Consultant"
            name="consultant"
            value={formData.consultant || ""}
            onChange={handleNameChange}
            onBlur={handleBlur}
          >
            <MenuItem value="">
              <em>Select Doctor</em>
            </MenuItem>
            {Object.entries(doctorGroups).map(([specialty, doctors]) => [
              <ListSubheader key={specialty}>{specialty}</ListSubheader>,
              doctors.map((doctor, idx) => (
                <MenuItem key={`${specialty}-${idx}`} value={doctor}>
                  {doctor}
                </MenuItem>
              ))
            ])}
          </Select>
          {errors.consultant && <FormHelperText>{errors.consultant}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={6} sm={3}>
        <Autocomplete
          freeSolo
          options={weightOptions || []}
          inputValue={formData.weight || ''}
          onInputChange={(event, newInputValue) => handleAutocompleteChange("weight", newInputValue)}
          renderInput={(params) => (
            <TextField {...params} label="Weight" name="weight" fullWidth />
          )}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField 
          label="UHID No" 
          name="uhid_no" 
          fullWidth 
          value={formData.uhid_no || ''} 
          InputProps={{ readOnly: true }} 
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Blood Type</InputLabel>
          <Select
            name="blood_group"
            value={formData.blood_group || ''}
            onChange={handleChange}
            label="Blood Type"
          >
            <MenuItem value=""><em>None</em></MenuItem>
            {bloodGroupOptions.map(bg => (
              <MenuItem key={bg} value={bg}>{bg}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6} sm={3}>
        <FormControl fullWidth>
          <InputLabel id="room-no-label">Room No</InputLabel>
          <Select
            labelId="room-no-label"
            name="room_no"
            value={formData.room_no || ''}
            label="Room No"
            onChange={handleChange}
          >
            <MenuItem value="">
              <em>Select Room</em>
            </MenuItem>
            {roomNoOptions.map((room, index) => (
              <MenuItem key={index} value={room}>
                {room}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField 
          label="Date" 
          inputProps={{ min: new Date().toISOString().slice(0, 16) }} 
          error={Boolean(errors.date)}
          helperText={errors.date} 
          name="date" 
          type="date" 
          InputLabelProps={{ shrink: true }} 
          fullWidth 
          onChange={handleChange} 
          value={formData.date || ''} 
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField 
          label="IP No" 
          InputProps={{ readOnly: true }} 
          name="ip_no" 
          fullWidth 
          value={formData.ip_no || ''} 
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          freeSolo
          options={diagnosisOptions || []}
          inputValue={formData.diagnosis || ''}
          onInputChange={(event, newInputValue) => handleAutocompleteChange("diagnosis", newInputValue)}
          renderInput={(params) => (
            <TextField {...params} label="Diagnosis" name="diagnosis" fullWidth />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default BasicInfoSection;
